import * as React from "react";
import FilterBar from "../common/FilterBar";
import { useFilters } from "../../hooks/useFilters";
import { AnyForNow } from "../../features/grn/types";

/**
 * Consolidated GRN Search Filter Component
 * @param {Object} props - Component props
 * @param {Array} props.warehouseOptions - Warehouse options for dropdown
 * @param {Array} props.grnStatusTypes - Status types for dropdown
 * @param {function} props.onFilterChange - Callback when filters change
 * @param {boolean} props.disableStatusField - Whether to disable status field
 * @param {boolean} props.includeReturnId - Whether to include return ID field
 */
interface FilterGrnSearchProps {
  warehouseOptions?: AnyForNow[];
  grnStatusTypes?: AnyForNow[];
  onFilterChange?: (filters: AnyForNow) => void;
  disableStatusField?: boolean;
  includeReturnId?: boolean;
}

const FilterGrnSearch: React.FC<FilterGrnSearchProps> = (props) => {
  const {
    warehouseOptions = [],
    grnStatusTypes = [],
    onFilterChange = () => {},
    disableStatusField = false,
    includeReturnId = false,
  } = props;

  const initialFilters: AnyForNow = {
    grnId: "",
    warehouse: "",
    status: "",
    fromDate: null,
    toDate: null,
    ...(includeReturnId && { grnreturncode: "" })
  };

  const { filters, updateFilter, updateFilters, clearFilters } = useFilters(initialFilters);

  const handleFilterChange = (newFilters: AnyForNow) => {
    updateFilters(newFilters);
    onFilterChange(newFilters);
  };

  const handleClearFilters = () => {
    clearFilters();
    const clearedFilters = { ...initialFilters };
    onFilterChange(clearedFilters);
  };

  const extraFields = includeReturnId ? [{ name: "grnreturncode", label: "Return ID" }] : [];

  return (
    <FilterBar
      filters={filters}
      onFilterChange={handleFilterChange}
      warehouseOptions={warehouseOptions}
      statusTypes={grnStatusTypes}
      disableStatusField={disableStatusField}
      extraFields={extraFields}
    />
  );
};

export default FilterGrnSearch;
